module.exports = __webpack_public_path__ + "img/edit-user-dialog.16571d62.png";